export default {
    "activatedFlag": false,
    "participantPhoneNumber": "3612281343",
    "planNumber": "104867"
}

